@if(l_external) {
    <a (click)="trg_btn()" class="{{ l_class }}" href="{{ l_target }}" target="_blank">
        @if(l_icon) { <fa-icon [icon]="faIcon" /> }
        <!-- <span>{{ l_txt | translate }}</span> -->
        <span>{{ l_txt }}</span>
    </a>
} 
@else {  
    <a (click)="trg_btn()" class="{{ l_class }}">
        @if(l_icon) { <fa-icon [icon]="faIcon" /> }
        <!-- <span>{{ l_txt | translate }}</span> -->
        <span>{{ l_txt }}</span>
    </a>
}
